// extracted by mini-css-extract-plugin
export var boldText = "_2c-4";
export var checkboxContainer = "_2c-6";
export var closeIcon = "_2c-i";
export var container = "_2c-0";
export var drawer = "_2c-8";
export var drawerContent = "_2c-9";
export var extraSmallText = "_2c-5";
export var fulfillmentGroupTable = "_2c-e";
export var largeText = "_2c-3";
export var loadingSpinnerContainer = "_2c-j";
export var mediumText = "_2c-2";
export var narrow = "_2c-f";
export var notificationLink = "_2c-l";
export var packageCheckIconContainer = "_2c-7";
export var slideoutHeaderActions = "_2c-g";
export var slideoutHeaderActionsShifted = "_2c-h";
export var slideoutHeaderContainer = "_2c-a";
export var slideoutModal = "_2c-c";
export var stickyHeaderWrapper = "_2c-b";
export var table = "_2c-k";
export var tableContainer = "_2c-d";
export var tertiaryText = "_2c-1";